import React, { Suspense, useState } from "react";
import {
  Alert,
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import LeftBG from "../assets/images/Vector52.png";
import LogoDesa from "../assets/images/register/desapedia.png";
import { config } from "../config";
import LoadingOverlay from "../component/Loading";
import axios from "axios";

const SigninForm = () => {
  const [modal, setModal] = useState(false);
  const [modalAwareness, setModalAwareness] = useState(true);
  const [form, setForm] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({
    message: "",
  });

  const [visibleError, setVisibleError] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const onDismiss = () => setVisibleError(false);
  const toggle = () => setModal(!modal);
  const toggleError = () => setModalError(!modalError);
  const toggleSuccess = () => setModalSuccess(!modalSuccess);

  const PreLoader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      </div>
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // --- FUNGSI VALIDASI EMAIL ---
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = async () => {
    toggle();
    setLoading(true);
    try {
      const dataToSend = {
        ...form,
        createdBy: "User Landing Page",
      };

      const headers = {
        "Content-Type": "application/json",
        // apikey: config.API_KEY,
      };

      const response = await axios.post(
        `${config.BASE_URL}registerDraft/create`,
        dataToSend,
        { headers }
      );

      if (response.status === 200) {
        setLoading(false);
        toggleSuccess();
      }
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setModalError(true);
      setLoading(false);
    }
  };

  const handleConfirm = (event) => {
    event.preventDefault();

    // 2. Validasi Email (TAMBAHAN BARU)
    if (!validateEmail(form.email)) {
      setVisibleError(true);
      setErrors({
        message: "Format Email tidak valid (contoh: user@mail.com)",
      });
      return;
    }

    // Jika semua valid
    setVisibleError(false);
    toggle();
    setErrors({ message: "" });
  };

  return (
    <React.Fragment>
      {loading && <LoadingOverlay />}

      <Modal
        isOpen={modalAwareness}
        toggle={() => setModalAwareness(false)}
        centered
      >
        <ModalHeader className="border-0 pb-0">
          <h5 className="fw-bold text-primary">Informasi Pendaftaran</h5>
        </ModalHeader>
        <ModalBody className="py-4">
          <div className="d-flex align-items-start">
            <div>
              <p className="mb-2">
                Halo! Jika sebelumnya Anda{" "}
                <strong>sudah pernah mendaftarkan email</strong> namun belum
                menyelesaikan pengisian data:
              </p>
              <ul className="ps-3 mb-0 text-muted shadow-none">
                <li>
                  Silakan periksa kotak masuk (Inbox) atau folder{" "}
                  <strong>Spam</strong> pada email Anda.
                </li>
                <li>
                  Gunakan <strong>link pendaftaran</strong> yang telah kami
                  kirimkan untuk melanjutkan proses.
                </li>
              </ul>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="border-0 pt-0">
          <Button
            size="sm"
            block
            style={{ background: "#FF5C30", border: "none" }}
            onClick={() => setModalAwareness(false)}
          >
            Saya Mengerti
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Success */}
      <Modal isOpen={modalSuccess} toggle={toggleSuccess} centered>
        <ModalBody>
          <Alert>
            <h4 className="alert-heading">Register Sukses!</h4>
            <p>
              Tautan pengisian formulir telah dikirim ke{" "}
              <strong>{form.email}</strong>. Segera cek kotak masuk atau folder{" "}
              <em>spam</em> Anda untuk melanjutkan.
            </p>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalSuccess(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Error */}
      <Modal isOpen={modalError} toggle={toggleError} centered>
        <ModalBody>
          {errorMessage
            ? errorMessage
            : "Maaf register saat ini tidak dapat dilakukan. Silahkan coba beberapa saat lagi"}
        </ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalError(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Konfirmasi */}
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalBody>Apakah Anda yakin ingin mengirim data berikut?</ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={onSubmit}
          >
            Iya
          </Button>
          <Button style={{ background: "gray" }} size="sm" onClick={toggle}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>

      <Suspense fallback={PreLoader}>
        <Container id="register-partner">
          <button
            style={{
              position: "absolute",
              zIndex: "100",
              left: 32,
              top: 24,
              background: "transparent",
              border: 0,
            }}
            onClick={() => (window.location.href = "/")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="white"
              className="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              />
            </svg>
          </button>

          <img src={LeftBG} alt="" />
          <div className="separator">
            <img src={LogoDesa} alt="desapedia" />
            <div className="form">
              <h1>Register</h1>
              {errors.message && (
                <Alert color="danger" isOpen={visibleError} toggle={onDismiss}>
                  {errors.message}
                </Alert>
              )}

              <form action="" onSubmit={handleConfirm}>
                <label htmlFor="email">Email</label>
                <input
                  name="email"
                  type="text"
                  id="email"
                  value={form.email}
                  onChange={handleInputChange}
                  placeholder="Isi Email Anda"
                />

                <input
                  type="submit"
                  value="Register"
                  disabled={!form.email}
                  style={{
                    display: "block",
                    margin: "20px auto",
                    padding: "12px 40px",
                    backgroundColor: "#FF8C69",
                    color: "white",
                    border: "none",
                    borderRadius: "15px 15px 15px 15px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: form.email ? "pointer" : "not-allowed",
                    width: "fit-content",
                  }}
                />
              </form>
            </div>
          </div>
        </Container>
      </Suspense>
    </React.Fragment>
  );
};

export default SigninForm;
